export default {
      id: "new-window-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite.svg#new-window",
      toString: function () {
        return this.url;
      }
    }